import service from './RestService';
import { RestResponse } from '../types/response/RestResponse';
import { Contact, ProjectSubcontractor, SubcontractorNotificationEmail } from '../state/subcontractors/types';
import { ExternalUserStatus } from '../enums/ExternalUserStatus';
import { NotificationsEmail, SubcontractorDetailsRequest } from '../state/project/types';

const path = '/subcontractors';

class SubcontractorService {
  getExternalUserContacts = (userId: number): RestResponse<Contact[]> => service.get(`${path}/${userId}/contacts`);

  addExternalUserContact = (externalUserContact: Contact, userId: number): RestResponse<null> =>
    service.post(`${path}/${userId}/contacts`, externalUserContact);

  updateExternalUserContact = (externalUserContact: Contact, userId: number, contactId: number): RestResponse<null> =>
    service.put(`${path}/${userId}/contacts/${contactId}`, externalUserContact);

  changeUserAccountStatus = (userId: number, status: boolean): RestResponse<null> => service.get(`${path}/${userId}/active/${status}`);

  getExternalUsersByProjectId = (projectId: number, status: ExternalUserStatus[]): RestResponse<ProjectSubcontractor[]> =>
    service.post(`${path}/projects/${projectId}`, { status });

  changeSubcontractorStatus = (subcontractorID: number, projectID: number, statusID: ExternalUserStatus): RestResponse<null> =>
    service.post(`${path}/${subcontractorID}/status`, { projectID, statusID });

  changeSubcontractorEmail = (subcontractorId: number, email: string): RestResponse<null> =>
    service.post(`${path}/${subcontractorId}/save-email?email=${email}`);

  createSubcontractorAccount = (data: SubcontractorDetailsRequest): RestResponse<null> => service.post(`${path}`, data);

  getSubcontractorNotificationEmailSettings = (subcontractorID: number): RestResponse<SubcontractorNotificationEmail[]> =>
    service.get(`${path}/${subcontractorID}/notification-email-settings`);

  editSubcontractorAccount = (subcontractorId: number, data: SubcontractorDetailsRequest): RestResponse<null> =>
    service.put(`${path}/${subcontractorId}`, data);

  saveSubcontractorNotificationEmail = (data: NotificationsEmail, subcontractorId: number): RestResponse<null> =>
    service.post(`${path}/${subcontractorId}/notification-email-settings`, data);

  changeSubcontractorVisibility = (projectId: number, subcontractorId: number, isHidden: boolean): RestResponse<null> =>
    service.post(`/projects/${projectId}/subcontractors/${subcontractorId}/update?isHidden=${isHidden}`);
}

export default new SubcontractorService();
